import React from 'react';

export type QueryParamTab = 'open' | 'expired' | 'draft';

export interface QueryParams {
  page: number;
  tab: QueryParamTab;
  q?: string;
  enabledFeatures: string[];
}

export interface UseQueryParams extends QueryParams {
  setPage(page: number): void;
  setTab(tab?: QueryParamTab): void;
  setQ(q?: string): void;
}

export const QueryParamContext = React.createContext<
  UseQueryParams | undefined
>(undefined);

export const useQueryParam = () => {
  const context = React.useContext(QueryParamContext);
  if (context === undefined) {
    throw new Error('useQueryParam must be used within a QueryParamProvider');
  }
  return context;
};
